// extracted by mini-css-extract-plugin
export default {"main":"a84799b2d6 _3c4b1d95a2","xmark":"_25e5d4dd4d","fl_img":"_08692d9aea _1ae5deeb92"};